import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { StateProvider } from "@/context/StateContext";
import { CartProvider } from "@/context/CartContext";
import AgeGate from "@/components/AgeGate";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Discover from "@/pages/Discover";
import Deals from "@/pages/Deals";
import ProductDetail from "@/pages/ProductDetail";
import DispensaryDetail from "@/pages/DispensaryDetail";
import Concierge from "@/pages/Concierge";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Pitch from "@/pages/Pitch";
import Scanner from "@/pages/Scanner";
import Wallet from "@/pages/Wallet";
import MyClaims from "@/pages/MyClaims";
import About from "@/pages/About";
import Billing from "@/pages/Billing";
import BillingSuccess from "@/pages/BillingSuccess";
import BillingCancel from "@/pages/BillingCancel";
import Cart from "@/pages/Cart";
import CartSuccess from "@/pages/CartSuccess";
import Community from "@/pages/Community";
import Privacy from "@/pages/Privacy";
import Sessions from "@/pages/Sessions";
import SessionRoom from "@/pages/SessionRoom";
import NotFound from "@/pages/NotFound";
import InstallPrompt from "@/components/InstallPrompt";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <StateProvider>
            <BrowserRouter>
              <AgeGate />
              <InstallPrompt />
              <Toaster position="top-right" theme="light" richColors />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/discover" element={<Discover />} />
                <Route path="/deals" element={<Deals />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/dispensary/:id" element={<DispensaryDetail />} />
                <Route path="/concierge" element={<Concierge />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/pitch" element={<Pitch />} />
                <Route path="/scan" element={<Scanner />} />
                <Route path="/wallet" element={<Wallet />} />
                <Route path="/me" element={<MyClaims />} />
                <Route path="/about" element={<About />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="/billing/success" element={<BillingSuccess />} />
                <Route path="/billing/cancel" element={<BillingCancel />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/cart/success" element={<CartSuccess />} />
                <Route path="/community" element={<Community />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/sessions" element={<Sessions />} />
                <Route path="/sessions/:sid" element={<SessionRoom />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </StateProvider>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
